<template>
  <label class="form-element">
    <span v-if="title" class="form-element__title" :class="[titleClass]">
      {{ title }} <span v-if="isRequired" class="red">*</span>
    </span>
    <div class="form-element__wrapper">
      <slot name="icon" />
      <component
        :is="tagName"
        v-bind="$attrs"
        :value="value"
        :disabled="disabled"
        :maxlength="maxLength"
        class="form-element__field"
        :class="[
          {
            'error': errorText,
            'with-icon': $slots.icon,
            'with-label': isPlaceholderStatic ? false : !title && (focused || value.toString()),
          },
        ]"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      />
      <span
        v-if="placeholder"
        class="form-element__placeholder"
        :class="[
          {
            hidden: isPlaceholderStatic ? value.toString() : title && value.toString(),
            label: isPlaceholderStatic ? false : !title && (focused || value.toString()),
            isRequired: isRequired && !title,
          },
        ]"
      >{{ placeholder }}</span>
      <span v-if="errorText && errorText.length" class="form-element__error">
        <div class="form-element__error-list">
          <div v-for="(error, index) in errorText" :key="index">
            <NotifyComponent :text="error" size="sm" :status="status" />
          </div>
        </div>
      </span>
    </div>
  </label>
</template>

<script lang="ts" src="./FormElement.ts"></script>

<style scoped lang="scss" src="./FormElement.scss"></style>
